export const sendLog = (payload: any): Promise<Response> => {
  return fetch(process.env.REACT_APP_STACK_DRIVER_LOGGING_URL, {
    body: JSON.stringify(payload),
    method: 'POST',
  });
};
